@use '@fukuri-admins/ui/layout' as *;

/* メインのWrapper */
.wrapper {
  width: 304px;
  display: flex;
  gap: 8px;
  align-items: center;
  border-radius: 4px;
  padding: 16px 12px;
  animation: fadeIn 0.3s ease forwards;
}

/* ステータス別のスタイル */
.success {
  background-color: background('Green');
  border: 1px solid border('Green_Darken');
  svg {
    color: text('Green');
  }
}

.danger {
  background-color: background('Red');
  border: 1px solid border('Red_Darken');
  svg {
    color: text('Red');
  }
}

/* 閉じるアニメーション */
.closing {
  animation: fadeOut 0.3s ease forwards;
}

/* 閉じるボタン */
.closeButton {
  display: inline-flex;
  margin-left: auto;
  padding: calc((16px - 14px) / 2) calc((16px - 8.75px) / 2);
  background-color: transparent;
  cursor: pointer;
  outline: none;
  border: none;
  appearance: none;
  border-radius: 100vh;

  svg {
    color: $NATURAL_500 !important;
  }
}

.closeButton:focus-visible {
  outline: -webkit-focus-ring-color auto 1px;
}

.closeButtonSuccess:hover {
  background-color: $SuccessMedium;
}

.closeButtonDanger:hover {
  background-color: $DangerMedium;
}

.message {
  color: text('Middle');
  font-size: 14px;
  line-height: 140%;
  white-space: pre-line;
}
